<ion-app>
  <ion-split-pane contentId="main-content" when="md" [disabled]="isAuthRoute || !isAuthenticated">
    <!-- Sidebar Menu -->
    <ion-menu contentId="main-content" [disabled]="isAuthRoute || !isAuthenticated">
      <ion-header>
        <ion-toolbar>
          <ion-title (click)="navigateTo('/')" style="cursor: pointer;">
            <div class="logo-container">
              <img src="../assets/images/ccn-logo-dark.svg" alt="CCN Logo" class="header-logo logo-dark">
              <img src="../assets/images/ccn-logo-light.svg" alt="CCN Logo" class="header-logo logo-light">
            </div>
          </ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list>
          <ion-menu-toggle [autoHide]="false" *ngFor="let p of appPages">
            <ion-item button [routerLink]="p.url" routerLinkActive="active-item" [routerLinkActiveOptions]="{exact: p.url === '/'}">
              <ion-icon slot="start" [name]="p.icon"></ion-icon>
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <div class="user-role">
          <ion-label>
            <span class="role-label">Name:</span>
            <span class="role-value">{{ userName || 'Unknown' }}</span>
          </ion-label>
          <ion-label>
            <span class="role-label">Role:</span>
            <span class="role-value" *ngIf="isCreator">Creator</span>
            <span class="role-value" *ngIf="isBusiness">Business</span>
            <span class="role-value" *ngIf="!isCreator && !isBusiness">User</span>
          </ion-label>
          <div class="theme-indicator">
            <ion-label>
              Theme: <span class="theme-value">{{isDarkMode ? 'Dark' : 'Light'}}</span>
            </ion-label>
          </div>
          <div class="build-number">
            <ion-label>Ver. 1.{{buildNumber}} (BETA)</ion-label>
          </div>
          <div class="feedback-action">
            <ion-button expand="block" size="small" (click)="openFeedback()">Send Feedback</ion-button>
          </div>
        </div>
      </ion-content>
    </ion-menu>

    <!-- Main Content Area -->
    <div class="ion-page" id="main-content" [class.auth-layout]="isAuthRoute || !isAuthenticated">
      <ion-router-outlet [attr.aria-hidden]="null"></ion-router-outlet>
    </div>
  </ion-split-pane>
</ion-app>
